import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, Renderer2, SimpleChanges } from '@angular/core';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import { SharedService } from 'src/app/back-office/modules/shared-service.service';
import config from 'config/default.json';
import { MatDialog } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { TableComponent } from '../table/table.component';
import { DomSanitizer } from '@angular/platform-browser';
import { DialogComponent } from '../dialog/dialog.component';

@Component({
  selector: 'app-upload-content',
  templateUrl: './upload-content.component.html',
  styleUrls: ['./upload-content.component.scss', '../../components/table/table.component.scss']
})
export class UploadContentComponent extends TableComponent{
  constructor(
    private elRef:ElementRef,
    private cdRef: ChangeDetectorRef,
    private renderer: Renderer2,
    private apiService: ApiServiceModule,
    private helper: HelperModule,
    public dialog: MatDialog,
    private sharedService: SharedService,
    public sanitizer: DomSanitizer
    ) {
      super(sanitizer);
    }
  PDFJS = (window as { [key: string]: any })["pdfjs-dist/build/pdf"];
  searchContentControl = new FormControl();
  @Output() inProgress = new EventEmitter<any>();
  @Input() platformInfos: any;
  @Input() userInfos: { [x:string]: any } = new Map();
  @Input() filterData:any;
  @Input() acceptedExtention: string[] = [];
  @Output() uploadEvent = new EventEmitter<any>();
  MAX_TOTAL_SIZE = 100 * 1024 * 1024;
  acceptedExtensionsString: string = '';
  formDataAndFiles:any  = new FormData();
  successMessage: string = '';
  warningMessage: string = '';
  errorMessage: string = '';
  nbFiles:number = 0;
  indexFile = 1;
  newFilesData: any[] = [];
  existingFilesData: any[] = [];

  ngOnInit(){
    this.acceptedExtensionsString = this.acceptedExtention.map((ext:any) => `.${ext}`).join(', ');
    this.manageSelectedFiles();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filterData'] && !changes['filterData'].firstChange) {
    }
  }
  checkUploadFiles(){
    let importPathName:string[];
    let data: any;
    let userInfos = this.userInfos;
    userInfos['navigation_infos'] = null;
    if(this.formDataAndFiles.getAll('file').length){
      if(this.platformInfos.key == 'vca'){
        let parents = this.filterData.parents;
        if(parents.structure && parents.structure.length == 1 && this.filterData.value.length){
          importPathName = [this.filterData.parents.country?.[0]?.name || '', this.filterData.parents.vca_institution?.[0]?.name || '', this.filterData.parents.structure?.[0]?.name || ''].filter((el:any)=>el != '');
          data = {
            id_structure: parents.structure[0].id,
            file_path_list: importPathName,
            user_infos: userInfos,
            platform_infos: this.platformInfos
          }
        }else{
          this.helper.showToast("Your filter is empty or contain some multiselects...");
          return;
        };
      }
      if(this.platformInfos.key == 'vcl'){
        let filterData = this.filterData.filter_data;
        let idCycle = filterData.cycle?.id || null;
        let idCountry = filterData.country?.id || null;
        let idRegion = filterData.region?.id || null;
        let idInstitution = filterData.vcl_institution?.id || null;
        if(idCycle && idCountry){
          importPathName = [filterData.country?.name || '', filterData.cycle?.name || '', filterData.region?.name || '', filterData.vcl_institution?.name || ''].filter((el:any)=>el != '');
          data = {
            id_cycle: idCycle,
            id_country: idCountry,
            id_region: idRegion,
            id_vcl_institution: idInstitution,
            file_path_list: importPathName,
            user_infos: userInfos,
            platform_infos: this.platformInfos
          }
        }else{
          this.helper.showToast("Your filter is empty or contain some multiselects...");
          return;
        };
      }
      if(this.platformInfos.key == 'epl'){
        data = {
          user_infos: userInfos,
          platform_infos: this.platformInfos
        }
        this.uploadContent(data);
      }
      if(['vca', 'vcl'].includes(this.platformInfos.key)){
        this.sharedService.sendData({in_progress: true});
        this.apiService.queryData(config.master.ndapi.url + '/enovsky/web/raw-content/get_suppliers', this.platformInfos, this.userInfos['access_token']).subscribe((response)=>{
          this.sharedService.sendData({in_progress: false});
          const dialogRef = this.dialog.open(DialogComponent, {
            width: '60%',
            position: {top: '30px' },
            data: {page: 'upload_content', user_infos: this.userInfos, suppliers: response, text: 'Your are about to upload contents inside: '+importPathName.join(' > '), }
          });
          dialogRef.afterClosed().subscribe((result:any) => {
            if(result.confirm){
              let inputData = {...data, ...result}
              this.uploadContent(inputData);
            }
          });
        });
      }
      
    }else this.helper.showToast("No file selected..."); 
  }
  buildPath(){
    return this.platformInfos.key == 'vca'? [this.filterData.parents.country?.[0]?.name || '', this.filterData.parents.vca_institution?.[0]?.name || '', this.filterData.parents.structure?.[0]?.name || ''].filter((el:any)=>el != ''):
      [this.filterData?.country?.name || '', this.filterData?.cycle?.name || '', this.filterData?.region?.name || '', this.filterData?.vcl_institution?.name || ''].filter((el:any)=>el != '');;
  }
  uploadContent(data: any){
    this.formDataAndFiles.append('data', JSON.stringify(data));
    this.successMessage = '';
    this.sharedService.sendData({in_progress: true});
    this.apiService.uploadDataAndFile(config.master.flapi.url + '/enovsky/upload_content', this.formDataAndFiles, this.userInfos['access_token']).subscribe((response:any)=>{
      if(response.status){
        this.errorMessage = '';
        this.successMessage = response.success;
        this.warningMessage = response.warning;
        this.helper.showToast(response.success); 
      }else{
        this.successMessage = '';
        this.warningMessage = '';
        this.errorMessage = response.error;
        this.helper.showToast(response.error); 
      }
      this.sharedService.sendData({in_progress: false});
      this.resetUpload();
      this.uploadEvent.emit(response);
    });
  }
  async onFileDroped(event:any){
    let parentName = this.buildPath().join(' > ');
    event.preventDefault();
    let files = event.dataTransfer.files;
    if (!this.canAddFiles(files)) return;
    for(var i = 0; i < files.length; i++){
      this.newFilesData.push({
        id_content: `N:${this.indexFile++}`,
        parent: parentName,
        module: null,
        details: files[i].name.split('.').pop()?.toUpperCase(),
        content_name: files[i].name,
        active: false,
        source: 'new'
      });
      this.formDataAndFiles.append("file", files[i]);
    } 
    this.setContentData();
    this.successMessage = this.formDataAndFiles.getAll('file')!.length+' selected file(s)';
    
  }
  async onFileSelected(event:any){
    let parentName = this.buildPath().join(' > ');
    let files = event.target.files;
    if (!this.canAddFiles(files)) return;
    for(var i = 0; i < files.length; i++){
      this.newFilesData.push({
        id_content: `N:${this.indexFile++}`,
        parent: parentName,
        module: null,
        details: files[i].name.split('.').pop()?.toUpperCase(),
        content_name: files[i].name,
        active: false,
        source: 'new',
      });
      this.formDataAndFiles.append("file", files[i]);
    } 
    this.setContentData();
    this.successMessage = this.formDataAndFiles.getAll('file').length+' selected file(s)';
  }
  manageSelectedFiles(){
    let that = this;
    let dragAndDropRef = this.elRef.nativeElement.querySelector('.drag_drop');
    this.elRef.nativeElement.querySelector('#select_files').addEventListener('change', (event:any)=>{
      that.nbFiles = event.target.files.length + that.nbFiles;
      dragAndDropRef.style.borderColor = '#333';
      that.successMessage = this.formDataAndFiles.getAll('file').length+' selected file(s)';
    }, false);
    
    dragAndDropRef.ondragover = function(event:any){
      this.style.borderColor = '#333';
      return false;
    }
    
    dragAndDropRef.ondragleave = function(event:any){
      this.style.borderColor = '#ccc';
      return false;
    }
  
 }
  resetUpload(){
    this.formDataAndFiles.delete('file');
    this.formDataAndFiles.delete('data');
    this.elRef.nativeElement.querySelector('#select_files').value = '';
    this.elRef.nativeElement.querySelector('.drag_drop').style.borderColor = '#ccc';
    this.successMessage = '';
    this.warningMessage = '';
    this.errorMessage = '';
    this.newFilesData = [];
    this.setContentData();
  }
  canAddFiles(files: FileList): boolean {
    let currentFiles = this.formDataAndFiles.getAll('file') as File[];
    let currentSize = 0;

    for (let f of currentFiles) {
      currentSize += f.size;
    }

    let addedSize = 0;
    for (let i = 0; i < files.length; i++) {
      addedSize += files[i].size;
    }

    if (currentSize + addedSize > this.MAX_TOTAL_SIZE) {
      this.errorMessage = 'Total file size exceeds 100 MB';
      this.successMessage = '';
      this.warningMessage = '';
      this.helper.showToast(this.errorMessage);
      return false;
    }

    return true;
  }
  loadExistingData(){
    this.filterData['search_key'] = this.searchContentControl.value;
    if(this.filterData && Object.keys(this.filterData).length > 0){
      //console.log(this.filterData)
      this.inProgress.emit(true);
      this.filterData.offset = this.navIndex * this.filterData.limit;
      this.apiService.queryData(config.master.ndapi.url + `/enovsky/web/raw-content/load_raw_project_content_${this.platformInfos.key}`, this.filterData, this.userInfos['access_token']).subscribe((response)=>{
        this.existingFilesData = response;
        this.setContentData();
        this.inProgress.emit(false);
        this.helper.showToast('Contents loaded...'); 
      });
    }
  }
  setContentData(){
    this.dataSource = [...this.newFilesData, ...this.existingFilesData];
    this.showedRows = this.dataSource;
    this.totalRows = this.dataSource?.[0]?.total_rows ?? 0;
    this.totalNavigations = Math.ceil(this.totalRows / this.filterData.limit);
  }
  toggleRow(row:any, clickedElm:any, rowTab:any){
    let toExpand = true;
    for (var tdTab of rowTab.querySelectorAll('.to_skip_element')){
      if(tdTab.contains(clickedElm)){
        toExpand = false;
        break;
      }
    }
    if(toExpand && row['source'] != 'new'){
      row['expanded'] =! row['expanded'];
      this.cdRef.detectChanges();
      if(row['expanded']){
        const index = this.showedRows.findIndex(e => e['id_content'] === row.id_content);
        
        if (index !== -1) this.showedRows[index]['pdf_data'] = {contents: [{id_content: row['id_content'], url: ['project', 'new'].includes(row['source'])? config.master.ndapi.url+'/'+this.platformInfos['root']+'/'+row['raw_file_path']: this.platformInfos['root']+'/'+row['raw_file_path']}], source: ['project', 'new'].includes(row['source'])? 'master': 'service', height: 320, refresh: true};
      }
    }
  }
  

  movePrevNextNavigation(action:string) {
    if (action == 'prev' && this.navIndex > 0) {
      this.navIndex--;
      this.loadExistingData();
    }
    if (action == 'next' && this.navIndex < this.totalNavigations - 1) {
      this.navIndex++;
      this.loadExistingData();
    }
  }
  selectAllOption(element: any){
    this.selectAll(element);
    this.cdRef.detectChanges();
  }
  applyFilterLocal(element:any, column:string){
    let tableBody = this.elRef.nativeElement.querySelector('tbody');
    this.removeDetailsRows(tableBody);
    this.applyFilter(element.value, column);
    this.cdRef.detectChanges();
  }
  applySortLocal(element:any, column:string, type:string){
    let tableBody = this.elRef.nativeElement.querySelector('tbody');
    this.removeDetailsRows(tableBody);
    this.applySort(element, column, type);
    this.cdRef.detectChanges();
  }
}
